import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle, ChartLegend } from "@progress/kendo-react-charts";
import { useApiTrigger } from "../../hooks/useApiTrigger";
import { forwardRef, useImperativeHandle } from "react";

const PieChart = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto } = useApiTrigger(data, filters);

    const getData = () => {
        const fileName = data.accion || 'Reporte_Grafica';
        returnData(dto, fileName);
    };

    useImperativeHandle(ref, () => ({
        exportChartData: getData,
    }));

    return (
        <Chart style={{ width: "100%", height: "100%" }}>
            <ChartTitle text={data.accion} />
            <ChartLegend position="top" orientation="horizontal" />
            <ChartCategoryAxis>
                <ChartCategoryAxisItem categories={dto.map(item => item.category)} />
            </ChartCategoryAxis>
            <ChartSeries>
                <ChartSeriesItem
                    type="pie"
                    overlay={{ gradient: 'sharpBevel' }}
                    data={dto}
                    tooltip={{ visible: true }}
                    categoryField="category"
                    field="value"
                />
            </ChartSeries>
        </Chart>
    )
})
export default PieChart